<sim-table-column-search
	[isShowing]="isSearchFieldVisible()"
	[searchableColumns]="searchableColumns()"
	[searchFilterValue]="stateService.searchFilters()?.[0]?.searchTerms?.[0]"
	(searchFilterValueChange)="setSearchTerm($event)"
	[(searchFilterColumn)]="searchColumn"
/>

<button mat-icon-button color="accent" class="searchButton" (click)="toggleFilterField()">
	<sim-animated-material-icon
		[trigger]="isSearchFieldVisible()"
		[endIcon]="{
			fontSet: 'fad',
			fontIcon: 'fa-times',
			themeColor: 'warn',
		}"
		[startIcon]="{
			fontSet: 'fad',
			fontIcon: 'fa-search',
			themeColor: 'accent',
		}"
	/>
</button>
